import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAuthenticated } from "auth/auth";

export default function ProtectedRoute({ permission }) {
    const { permissions } = useSelector(state => state.auth);
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }

    if (permission && !permissions.includes(permission)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};
